export default {
  data: () => ({

    products: {
      'PATROWLHEARS': {
        'SAAS': {
          // 'PATROWLHEARS_SAAS_STARTER': {
          'HEARS_STARTER': {
            title: 'Starter',
            subtitle: 'For individuals with security concerns',
            price_id: '',
            amount_monthly: '',
            quantity: 1,
            is_default: false,
            is_quantity_ajustable: false,
            features: {
              public_feeds: {color: 'green', icon: 'mdi-check', text: 'Public Feeds'},
              patrowlcert_feeds: {color: 'green', icon: 'mdi-check', text: 'PatrowlCERT Private Feeds'},
              patrowl_scoring: {color: 'green', icon: 'mdi-check', text: 'Patrowl Threat Scoring'},
              // manage_feeds: {color: 'green', icon: 'mdi-check', text: 'Manage Private Feeds'},
              team_sharing: {color: 'red', icon: 'mdi-close', text: 'Team sharing'},
              spacer_1: {type: 'spacer'},
              monitoring: {color: 'green', icon: 'mdi-check', text: 'Monitor assets', value: 'Enabled'},
              alerting: {color: 'green', icon: 'mdi-check', text: 'Alerting', value: 'Slack, Email, Teams'},
              // ticketing: {color: 'red', icon: 'mdi-close', text: 'Ticketing'},
              // authentication: {color: 'red', icon: 'mdi-close', text: 'Authentication', value: ''},
              users: {color: 'green', icon: 'mdi-check', text: 'Users', value: '1'},
              api_ratio: {color: 'green', icon: 'mdi-check', text: 'API requests', value: '/day'},
              spacer_2: {type: 'spacer'},
              // branding: {color: 'red', icon: 'mdi-close', text: 'Brand customization'},
              commercial_use: {color: 'red', icon: 'mdi-close', text: 'Commercial Use'},
              // support: {color: 'primary', icon: 'mdi-check', text: 'Support', value: 'Standard'},
            }
          },
          // 'PATROWLHEARS_SAAS_PRO': {
          'HEARS_PRO': {
            title: 'Professionals',
            subtitle: 'For security teams, SOC/CSIRT and MSSP',
            price_id: '',
            amount_monthly: '',
            quantity: 3,
            is_quantity_ajustable: true,
            quantity_min: 3,
            is_default: true,
            features: {
              public_feeds: {color: 'green', icon: 'mdi-check', text: 'Public Feeds'},
              patrowlcert_feeds: {color: 'green', icon: 'mdi-check', text: 'PatrowlCERT Private Feeds'},
              patrowl_scoring: {color: 'green', icon: 'mdi-check', text: 'Patrowl Threat Scoring'},
              // manage_feeds: {color: 'green', icon: 'mdi-check', text: 'Manage Private Feeds'},
              team_sharing: {color: 'green', icon: 'mdi-check', text: 'Team sharing'},
              spacer_1: {type: 'spacer'},
              monitoring: {color: 'green', icon: 'mdi-check', text: 'Monitor assets', value: 'Enabled'},
              alerting: {color: 'green', icon: 'mdi-check', text: 'Alerting', value: 'Slack, Email, Teams'},
              // ticketing: {color: 'red', icon: 'mdi-close', text: 'Ticketing'},
              // authentication: {color: 'red', icon: 'mdi-close', text: 'Authentication', value: ''},
              users: {color: 'green', icon: 'mdi-check', text: 'Users', value: '2 minimum'},
              api_ratio: {color: 'green', icon: 'mdi-check', text: 'API requests', value: '/day'},
              spacer_2: {type: 'spacer'},
              // branding: {color: 'green', icon: 'mdi-check', text: 'Brand customization'},
              commercial_use: {color: 'green', icon: 'mdi-check', text: 'Commercial Use'},
              // support: {color: 'green', icon: 'mdi-check', text: 'Support', value: 'Gold'},
            }
          },
        },
        'ON-PREMISE': {
        }
      },
    },
  }),
  methods: {

  },
  mounted() {
  },
  destroyed() {
  }
};
